<div
  class="wager-card"
  [class.row]="isRow()"
  [ngStyle]="cardStyle | theme"
  [style.padding-top]="topPadding"
  [style.padding-bottom]="bottomPadding"
  [style.padding-left]="leftPadding"
  [style.padding-right]="rightPadding"
  [attr.role]="isRow() ? null : 'button'"
  [attr.tabindex]="isRow() ? null : 0"
  [attr.aria-label]="isRow() ? null : title() + ' — ' + buttonLabel()"
  (keydown.enter)="onClick()"
  (keydown.space)="onClick()"
  (click)="onClick()"
>
  @if (splicedBg) {
    <app-spliced-background [image]="splicedBg.imageUrl" [cornerSize]="splicedBg.cornerSize" />
  }
  <div class="labels">
    <div [ngStyle]="titleStyles | theme">
      {{ title() }}
    </div>
    <app-wager-prize
      [primary]="prizeAmount()"
      [textStyles]="prizeStyles"
      [shadowStyles]="prizeShadowStyles"
    />
    <div [ngStyle]="enterStyle | theme">
      {{ buttonLabel() }}
    </div>
  </div>
  @if (isRow()) {
    <app-link-button
      class="row-play"
      [label]="playNowLabel"
      [arrow]="true"
      (clickEvent)="onClick()"
    />
  } @else {
    <div class="play-button" [ngStyle]="playButtonStyles | theme">
      @if (splicedPlayBg) {
        <app-spliced-background
          [image]="splicedPlayBg.imageUrl"
          [cornerSize]="splicedPlayBg.cornerSize"
        />
      }
      <span [ngStyle]="playButtonLabelStyles | theme">{{ playLabel }}</span>
    </div>
  }
</div>
